<template>
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="31" fill="white" stroke="#B4B5B7" />
    <path
      d="M26 33.5V35.5C26 36.0523 26.4477 36.5 27 36.5C27.5523 36.5 28 36.0523 28 35.5V33.5C28 32.9477 27.5523 32.5 27 32.5C26.4477 32.5 26 32.9477 26 33.5Z"
      fill="#8A8A8F"
    />
    <path
      d="M26 41.5V39.5C26 38.9477 26.4477 38.5 27 38.5C27.5523 38.5 28 38.9477 28 39.5V41.5C28 42.0523 27.5523 42.5 27 42.5C26.4477 42.5 26 42.0523 26 41.5Z"
      fill="#8A8A8F"
    />
    <path
      d="M26 45.5V47.5C26 48.0523 26.4477 48.5 27 48.5C27.5523 48.5 28 48.0523 28 47.5V45.5C28 44.9477 27.5523 44.5 27 44.5C26.4477 44.5 26 44.9477 26 45.5Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 20C22 18.1547 24.3094 17 27 17C29.6906 17 32 18.1547 32 20C32 21.8453 29.6906 23 27 23C24.3094 23 22 21.8453 22 20ZM29.3812 19.4802C28.7826 19.1809 27.9272 19 27 19C26.0728 19 25.2174 19.1809 24.6188 19.4802C24.1772 19.701 24 19.9105 24 20C24 20.0895 24.1772 20.299 24.6188 20.5198C25.2174 20.8191 26.0728 21 27 21C27.9272 21 28.7826 20.8191 29.3812 20.5198C29.8228 20.299 30 20.0895 30 20C30 19.9105 29.8228 19.701 29.3812 19.4802Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 20C14 15.9456 19.8912 13 27 13C27.3362 13 27.6697 13.0066 28 13.0196V13H48C49.5977 13 50.9037 14.2489 50.9949 15.8237L51 16V43C51 44.5977 49.7511 45.9037 48.1763 45.9949L48 46H40V47.4418L39.6733 47.7393C36.6599 50.4839 32.5309 51.8447 27.3347 51.8447C22.3304 51.8447 18.1177 50.5836 14.7295 48.0525L14.382 47.7862L14 47.4859V21H14.1226C14.0418 20.6753 14 20.3416 14 20ZM16 23.8011V46.503L16.2659 46.6968C19.1242 48.7151 22.6423 49.7654 26.8466 49.8404L27.3347 49.8447C31.7484 49.8447 35.2203 48.7974 37.7898 46.7213L38 46.545V23.8011C35.8302 25.6449 32.1025 26.8428 27.8577 26.9856C27.9481 27.1359 28 27.3119 28 27.5V29.5C28 30.0523 27.5523 30.5 27 30.5C26.4477 30.5 26 30.0523 26 29.5V27.5C26 27.3119 26.0519 27.1359 26.1423 26.9856C21.8975 26.8428 18.1698 25.6449 16 23.8011ZM39.8774 21H40V44H48C48.5128 44 48.9355 43.614 48.9933 43.1166L49 43V16C49 15.4872 48.614 15.0645 48.1166 15.0067L48 15H36.2044C38.5432 16.2419 40 17.9839 40 20C40 20.3416 39.9582 20.6753 39.8774 21ZM38 20C38 17.427 33.146 15 27 15C20.854 15 16 17.427 16 20C16 22.573 20.854 25 27 25C33.146 25 38 22.573 38 20Z"
      fill="#8A8A8F"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ToiletTraining',
};
</script>
